import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Select } from 'components/DesignSystem/Select';
import { createFilterControl } from 'components/DesignSystem/Select/components/FilterControl/FilterControl';

interface Props {
    selectedTag: ISelectOption<number> | null;
    handleSelectedTagChange: (selectedTag: ISelectOption<number> | null) => void;
    tagOptions: ISelectOption<number>[];
}
const FilterControl = createFilterControl({
    icon: <MuiIcon icon={'label'} type={'outlined'} fontSize={'18px'} color={'inherit'} />,
    filterName: 'Tags',
});

export const TagsFilter = ({ selectedTag, handleSelectedTagChange, tagOptions }: Props) => {
    return (
        <Select<ISelectOption<number>>
            value={selectedTag}
            options={tagOptions}
            onChange={(value) => handleSelectedTagChange(value ?? null)}
            menuPlacement={'auto'}
            placeholder={'All'}
            boldPlaceholder={true}
            isClearable={true}
            components={{
                Control: FilterControl,
            }}
        />
    );
};
